import { Container } from "reactstrap"
import { BackButton } from "../../components/BackButton"
import { useHistory } from "react-router-dom"
import axios from "axios"
import { useEffect, useState } from "react"
import { CustomButton, Card } from "../../components"
import ResultsCard from "../../pages/childDashboard/components/ResultsCard"
import { levelcolors, COLORS } from "../../constants"
import styled from "styled-components"
import { Row, Col } from "reactstrap"
import ReactLoading from "react-loading"
import { BlobProvider } from "@react-pdf/renderer"
import Certificate from "../../pdf/Certificate"

const StyledCircle = styled.div`
    width: ${props => props.circleWidth ? props.circleWidth : "80px"};
    height: ${props => props.circleWidth ? props.circleWidth : "80px"};
    border-radius: 50%;
    font-size: 35px;
    background-color: ${props => props.bgcolor};
    color: ${props => props.textcolor};

    justify-content: center;
    align-items: center;
    display: ${props => props.displayCircle == false ? 'none' : 'flex'};
`;
function Certificates(props) {
    const [wordsLearned, setWordsLearned] = useState([]);
    const [badgeData, setBadgeData] = useState();
    const [wordsLoading, setWordsLoading] = useState(true);
    const [pupilLoading, setPupilLoading] = useState(true);
    const [badgesLoading, setBadgesLoading] = useState(true);
    const [pupilData, setPupilData] = useState();
    const { id } = props.match.params;
    const api = process.env.REACT_APP_API_URL;
    const history = useHistory();



    useEffect(async () => {

        async function fetchData() {
            const response = await axios.get(`${api}/cp/pupil_words_by_level/${id}`);
            setWordsLearned(response.data.words_learned_by_level);
            setWordsLoading(false);

        }
        async function fetchPupilData() {
            const response = await axios.get(`${api}/cp/pupil/${id}`);
            setPupilData(response.data.pupil);
            setPupilLoading(false);

        }
        async function fetchBadges() {

            const response = await axios.get(`${api}/cp/badge_achievements/${id}`);
            console.log(response.data)
            setBadgeData(response.data.badges);
            console.log(response.data.badges)
            setBadgesLoading(false);
        }

        fetchData();
        fetchPupilData();
        fetchBadges();
        // fetchTest();

    }, [])
    // const getAllBadges = (levelno) => {
    //     axios.get(`${api}/cp/badge_achievements/${id}/${levelno}`, {
    //         headers: {
    //             'Accept': 'application/json'
    //         }
    //     }).then(res => {
    //         console.log(res.data)
    //         return res.data;
    //     });

    // }
    const check = (wordsLearned) => {
        var count = 0;

        wordsLearned.map(item => {
            if (item.words_learned == 0) {
                count++;
            }
        })
        return count;
    }
    if (badgesLoading || pupilLoading || wordsLoading) {
        return <div>
            <BackButton onClick={() => history.goBack()} />

            <div className="w-100 d-flex justify-content-center">
                <ReactLoading type="bubbles" color={COLORS.green} height={130} width={200} />
            </div>
        </div>
    } else {


        return (
            <div>
                <BackButton onClick={() => history.goBack()} />
                {pupilData && <h5 className="text-center mb-3">{pupilData.first_name} {pupilData.last_name} Certificates</h5>}
                {check(wordsLearned) == 6 && <div className="text-center color-text-green">No games played</div>}
                <ul className="list-unstyled">
                    {wordsLearned.map((item, i) => {

                        if (item.words_learned != 0) {
                            return <li key={i} className="w-100 mb-3">
                                <Card className="w-100" style={{ paddingTop: 10, paddingBottom: 10 }}>

                                    <Row>
                                        <Col md={2} className="d-flex justify-content-center align-items-center flex-column">
                                            <StyledCircle textcolor={levelcolors[i].color} bgcolor={levelcolors[i].bgColor}><div>{item.level_no}</div></StyledCircle>
                                        </Col>
                                        <Col md={5} className="d-flex justify-content-center dynamic-flex-center flex-column py-3">
                                            <h5 className="mb-0">Level {item.level_no}</h5>
                                            <span><span className="color-text-grey">Words Learned • </span><span style={{ fontSize: 23, color: levelcolors[i].bgColor }}>{item.words_learned}</span><span style={{ fontSize: 23 }}>/300</span></span>


                                            {badgeData ? badgeData[i].bronze_achieved == null ?
                                                <span>
                                                    <span style={{ fontSize: 20, color: levelcolors[i].bgColor }}>{100 - item.words_learned}</span> words to achieve Bronze Certificate
                                                </span>
                                                :
                                                badgeData[i].bronze_achieved != null && badgeData[i].silver_achieved == null ?
                                                    <span>
                                                        <span style={{ fontSize: 20, color: levelcolors[i].bgColor }}>{200 - item.words_learned}</span> words to achieve Silver Certificate
                                                    </span>
                                                    :
                                                    badgeData[i].bronze_achieved != null && badgeData[i].silver_achieved != null && badgeData[i].gold_achieved == null ?
                                                        <span>
                                                            <span style={{ fontSize: 20, color: levelcolors[i].bgColor }}>{300 - item.words_learned}</span> words to achieve Gold Certificate
                                                    </span>
                                                        :
                                                        <span>Your child lerned all the words inside this level, print out any certificate!</span>
                                                : null}

                                        </Col>
                                        <Col md={5} className="d-flex justify-content-center flex-column">
                                            {!badgeData ? null :
                                                <div className="d-flex justify-content-center flex-wrap">
                                                    <BlobProvider document={<Certificate level={item.level_no} date={badgeData[i].bronze_achieved} type="Bronze" name={pupilData.first_name + " " + pupilData.last_name} />}>
                                                        {({ url }) => (
                                                            <a href={url} target="_blank">
                                                                <CustomButton disabled={badgeData && badgeData[i].bronze_achieved == null ? true : false} className="mr-1" bgColor="#C38242" color={COLORS.dark_orange} hover="#a36d36" style={{ paddingLeft: 10, paddingRight: 10, height: 45 }}>
                                                                    Bronze
                                                                </CustomButton>
                                                            </a>
                                                        )}
                                                    </BlobProvider>
                                                    <BlobProvider document={<Certificate level={item.level_no} date={badgeData[i].silver_achieved} type="Silver" name={pupilData.first_name + " " + pupilData.last_name} />}>
                                                        {({ url }) => (
                                                            <a href={url} target="_blank">
                                                                <CustomButton disabled={badgeData && badgeData[i].silver_achieved == null ? true : false} className="mr-1" bgColor="#c6c6c6" color="#707070" hover="#999999" style={{ paddingLeft: 10, paddingRight: 10, height: 45 }}>
                                                                    Silver
                                                        </CustomButton>
                                                            </a>
                                                        )}
                                                    </BlobProvider>
                                                    <BlobProvider document={<Certificate level={item.level_no} date={badgeData[i].gold_achieved} type="Gold" name={pupilData.first_name + " " + pupilData.last_name} />}>
                                                        {({ url }) => (
                                                            <a href={url} target="_blank">
                                                                <CustomButton disabled={badgeData && badgeData[i].gold_achieved == null ? true : false} className="mr-1" bgColor="#ffc001" color="#946f00" hover="#bd8e00" style={{ paddingLeft: 10, paddingRight: 10, height: 45 }}>
                                                                    Gold
                                                        </CustomButton>
                                                            </a>
                                                        )}
                                                    </BlobProvider>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </Card>
                            </li>
                        }
                    })}
                </ul>

            </div>

        );
    }
}

export default Certificates;